import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import CardWrapper from './components/CardWrapper/CardWrapper';
import SideBar from './components/SideBar/SideBar';

function App() {
  const [selectedType, setSelectedType] = useState(null);
  const [isListVisible, setIsListVisible] = useState(true);
  const [showEditor,setShowEditor] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex">
      <SideBar 
        selectedType={selectedType} 
        setSelectedType={setSelectedType}
        isListVisible={isListVisible}
        setIsListVisible={setIsListVisible}
      />
      <div className={`
        flex-1 transition-all duration-300 ease-in-out
        ${isListVisible ? 'ml-[450px]' : 'ml-64'}
      `}>
        {/* <Header /> */}
        <CardWrapper selectedType={selectedType} showEditor={showEditor} setSelectedType={setSelectedType} setShowEditor={setShowEditor} />
      </div>
    </div>
  );
}

export default App;
